import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import GuaranteeIcon from "../../Assets/Images/guarantee-icon.svg";
import AcceleratedIcon from "../../Assets/Images/accelerate-benefit-icon.svg";
import PolicyIcon from "../../Assets/Images/policy-icon.svg";
import AutomaticIcon from "../../Assets/Images/automatic-benefit-icon.svg";
import { useTranslation } from "../../Hooks/useTranslation"; // Import the hook
import coverImage from "../../Assets/Images/term-benefits-img.png"; // Adjust the path as necessary
import coverImage2 from "../../Assets/Images/term-benefits-img-2.png"; // Adjust the path as necessary

export default function BenefitsMobileSlider() {
  const translations = useTranslation(); // ✅ Only declared once

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    adaptiveHeight: true,
  };

  return (
    <Slider {...settings} className="vs-slider relative  w-[100%]  pl-[20px] ">
      {/* Slide 1 */}
      <div className="flex-1 shrink pt-[60px] lg:pt-[60px] md:pt-[8rem]  lg:px-0 lg:w-[50%]">
        <div className="pb-[5%] px-4 animate__animated animate__fadeInLeft">
          <div className="text-sm text-gray-600 mb-1 learnmoreacc">
            {translations.select_term}
          </div>
          <div className="text-[24px] lg:text-[40px]">
            <span className="font-semibold">{translations.main_benefits}</span>{" "}
            {translations.of_the_policy}
          </div>
        </div>
        <div className="circle-div lg:ml-0 mb-[0] md:mb-0 max-h-[688px] animate__animated animate__fadeInRight">
          <img src={coverImage} width={"100%"} className="object-cover" />
        </div>
        <div className="py-[40px] px-4">
          <div className="flex pb-[2rem] md:pb-[4.5rem] animate__animated animate__fadeInLeft min-h-[167px]">
            <div className="pe-[1.8rem] flex-none">
              <img src={GuaranteeIcon} className="w-[84px]" />
            </div>
            <div className="max-w-[355px]">
              <h3 className="md:text-[24px] text-[16px] font-semibold md:mb-2.5 mb-2">
                {translations.guaranteed_premiums_title}
              </h3>
              <p className="md:text-[16px] text-[14px]">
                {translations.guaranteed_premiums_desc}
              </p>
            </div>
          </div>
          <div className="flex animate__animated animate__fadeInLeft">
            <div className="pe-[1.8rem] flex-none">
              <img src={PolicyIcon} className="w-[84px]" />
            </div>
            <div className="max-w-[355px]">
              <h3 className="md:text-[24px] text-[16px] font-semibold md:mb-2.5 mb-2">
                {translations.conversion_option_title}
              </h3>
              <p className="md:text-[16px] text-[14px]">
                {translations.conversion_option_desc}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Slide 2 */}
      <div className="flex-1 shrink pt-[60px] lg:pt-[60px] md:pt-[8rem]  lg:px-0 lg:w-[50%] ">
        <div className="pb-[5%] px-4 animate__animated animate__fadeInLeft">
          <div className="text-sm text-gray-600 mb-1 learnmoreacc">
            {translations.select_term}
          </div>
          <div className="text-[24px] lg:text-[40px]">
            <span className="font-semibold">{translations.main_benefits}</span>{" "}
            {translations.of_the_policy}
          </div>
        </div>
        <div className="circle-div lg:ml-0 mb-[0] md:mb-0 max-h-[688px] animate__animated animate__fadeInRight">
          <img src={coverImage2} width={"100%"} className="object-cover" />
        </div>
        <div className="py-[40px] px-4">
          <div className="flex pb-[2rem] md:pb-[4.5rem] animate__animated animate__fadeInLeft">
            <div className="pe-[1.8rem] flex-none">
              <img src={AcceleratedIcon} className="w-[84px]" />
            </div>
            <div className="max-w-[355px]">
              <h3 className="md:text-[24px] text-[16px] font-semibold md:mb-2.5 mb-2">
                {translations.acceleratedDeathBenefitTitle}
              </h3>
              <p className="md:text-[16px] text-[14px]">
                {translations.acceleratedDeathBenefitDesc}
              </p>
            </div>
          </div>
          <div className="flex animate__animated animate__fadeInLeft">
            <div className="pe-[1.8rem] flex-none">
              <img src={AutomaticIcon} className="w-[84px]" />
            </div>
            <div className="max-w-[355px]">
              <h3 className="md:text-[24px] text-[16px] font-semibold md:mb-2.5 mb-2">
                {translations.automaticBenefitRiderTitle}
              </h3>
              <p className="md:text-[16px] text-[14px]">
                {translations.automaticBenefitRiderDesc}
              </p>
            </div>
          </div>
        </div>
      </div>
    </Slider>
  );
}
